import React from 'react';

/**
 * D12 — Single shared Suspense fallback that reuses the static shell's
 * "JyotishPuraan — loading…" progress bar from public/index.html.
 */
const AppShellFallback = () => (
  <div
    className="jp-shell-wrap"
    data-testid="jp-suspense-fallback"
    style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px 16px',
      boxSizing: 'border-box',
      backgroundColor: '#120228',
      color: '#F1EEF8',
    }}
  >
    <div
      className="jp-shell-progress-box"
      role="status"
      aria-live="polite"
      style={{ width: '100%', maxWidth: 320, margin: '0 auto', textAlign: 'center' }}
    >
      <p
        className="jp-shell-progress-label"
        style={{ fontSize: 13, fontWeight: 600, color: '#F5D478', margin: '0 0 8px' }}
      >
        JyotishPuraan — loading…
      </p>
      <div
        className="jp-shell-progress-track"
        role="progressbar"
        aria-label="JyotishPuraan — loading…"
        style={{
          width: '100%',
          height: 6,
          borderRadius: 999,
          background: 'rgba(255, 255, 255, 0.10)',
          border: '1px solid rgba(212, 165, 53, 0.28)',
          overflow: 'hidden',
        }}
      >
        <div
          className="jp-shell-progress-bar"
          style={{
            width: '45%',
            height: '100%',
            borderRadius: 999,
            background: 'linear-gradient(90deg, #B8860B 0%, #F5D478 50%, #D4A535 100%)',
          }}
        />
      </div>
    </div>
  </div>
);

export default AppShellFallback;
